import { Injectable } from '@angular/core';

const SESSION_OWNER_KEY = 'apgap.sessionOwner';

/**
 * Remembers which account the persisted state belongs to.
 *
 * Rehydration happens while the injector is built, long before the router,
 * postVerifyUser(), or any /me call. Nothing else in the app can tell whether
 * the state read off disk belongs to the account that is actually signing in,
 * so the owner is stamped here and compared once /me answers.
 *
 * Deliberately kept outside NgRx: it has to survive the session reset that it
 * triggers.
 */
@Injectable({
  providedIn: 'root',
})
export class SessionOwnerService {
  public read(): number | null {
    try {
      const stored = localStorage.getItem(SESSION_OWNER_KEY);
      if (stored === null) return null;
      const parsed = Number(stored);
      return Number.isFinite(parsed) ? parsed : null;
    } catch {
      // localStorage may be unavailable (private mode); treat as no owner.
      return null;
    }
  }

  public write(userId: number): void {
    try {
      localStorage.setItem(SESSION_OWNER_KEY, String(userId));
    } catch {
      // Nothing to do; the identity check simply degrades to a no-op.
    }
  }

  public clear(): void {
    try {
      localStorage.removeItem(SESSION_OWNER_KEY);
    } catch {
      // Nothing to do.
    }
  }
}
